import {Router} from '@angular/router'
import {ChangeDetectorRef, Component, inject, OnDestroy, OnInit} from '@angular/core'
import {combineLatest, Observable, Subject, Subscription} from 'rxjs'
import {filter, map, switchMap, take, takeUntil, tap} from 'rxjs/operators'
import {AsyncPipe, NgFor, NgIf} from '@angular/common'
import {CustomModalComponent} from "../../../shared/ui/custom-modal/custom-modal.component";
import {CollaborateurDto} from "src/app/shared/models/collaborateursDto";
import {CollaborateurDomainService} from "../../domain/collaborateur.domain";
import {EquipeGlobaleDomainService} from "../../domain/equipeglobale.domain";
import {ToastDomainService} from "../../../shared/ui/toast/domain/toast.domain";
import {localeFr} from "../../../../assets/localization/ag-grid/ag-grid-locale-fr";
import {
    CellClickedEvent,
    ColDef,
    ICellRendererParams,
    ITooltipParams,
    RowClassParams
} from "ag-grid-community";
import {AgGridAngular} from "ag-grid-angular";
import {UserState} from "../../../core/data-access/state/user.state";
import dayjs from "dayjs";
import {TypeToast} from "../../../shared/ui/toast/state/toast.state";

@Component({
    selector: 'app-equipe-directe',
    templateUrl: './equipe-directe.component.html',
    styleUrls: ['./equipe-directe.component.scss'],
    imports: [NgIf, CustomModalComponent, NgFor, AsyncPipe, AgGridAngular]
})
export class EquipeDirecteComponent implements OnInit, OnDestroy {
    public collabsNumber: number = 0
    public collabsNumberAvenir: number = 0
    // matricule of last collab added,  for scrolling to
    public matriculeToScrollTo: string = ''
    public showValidateButton: boolean = false
    // remove a collab variables
    public confirmRemoveModalIsVisible: boolean = false
    public confirmAddModalIsVisible: boolean = false
    public modalTitleRemove: string = 'Confirmation de suppression'
    public modalTitleAdd: string = "Confirmez l'ajout de ces collaborateurs dans <br />votre équipe ?"
    public collabMatriculeToRemove: string = ''
    public prenomCollaborateur: string = ''
    public nomCollaborateur: string = ''
    public collabsSelectedName: Array<string> = []
    private equipeGlobaleDomainService = inject(EquipeGlobaleDomainService)
    private collaborateurDomainService = inject(CollaborateurDomainService)
    monEquipeActuelleSorted$: Observable<Array<CollaborateurDto>> = this.collaborateurDomainService.monEquipeActuelleSorted$
    monEquipeAVenir$: Observable<CollaborateurDto[]> = this.collaborateurDomainService.monEquipeAVenir$
    collaborateursLoading$: Observable<boolean> = this.collaborateurDomainService.collaborateurStateLoading$
    collaborateursSelected$: Observable<Array<CollaborateurDto>> = this.collaborateurDomainService.selectedCollaborateurs$
    private toastDomainService = inject(ToastDomainService)
    private unsubscribe$ = new Subject<void>()

    public colDefsMonEquipe: ColDef[] = [];
    public colDefsMonEquipeAvenir: ColDef[] = [];
    private readonly userState = inject(UserState)
    user$ = this.userState.store.select(UserState.getUser)
    private currentUserMatricule: string | null = null;
    private userSubscription!: Subscription;

    private cdr = inject(ChangeDetectorRef)

    protected getRowClass: (params: RowClassParams) => string = (params: RowClassParams): string => {
        if (params.data?.datefilled === true) {
            return 'highlighted'
        }
        return ''
    }

    defaultColDef: ColDef = {
        sortable: true,
        unSortIcon: true,
        suppressHeaderMenuButton: true,
        suppressHeaderContextMenu: true,
        filter: 'agTextColumnFilter',
        filterParams: { maxNumConditions: 1, filterOptions: ['contains', 'equals', 'notContains', 'notEqual'] }
    }

    buildColumnDefsMonEquipe(): void {
        const baseColDefsMonEquipe: ColDef[] = [
            {
                headerName: 'tri',
                valueGetter: (params) => params.data.datefilled,
                flex: 0,
                hide: true,
                sort: 'desc',
                sortIndex: 1, // Première clé de tri
            },
            {
                headerName: 'Collaborateurs',
                valueGetter: (params) =>
                    params.data.nomCollaborateur +
                    ' ' +
                    params.data.prenomCollaborateur,
                flex: 1,
                sort: 'asc',
                sortIndex: 2,
                cellStyle: (params: any) => {
                    // params peut être CellStyleParams
                    if (params.data && params.data.datefilled != null && params.data.datefilled === true) {
                        return { background: 'var(--color-row-highlighted)' }
                    } else {
                        return null
                    }
                },
            },
            {
                headerName: 'Emploi repère',
                valueGetter: (params) => params.data.nomEmploi,
                flex: 1,
            },
            {
                headerName: 'Direction / agence / service',
                valueGetter: (params) => params.data.nomEntiteAffectation,
                flex: 1,
            },
            {
                headerName: "Dans l'équipe depuis",
                valueGetter: (params) => {
                    if (params.data && params.data.datefilled != null && params.data.datefilled === true) {
                        return dayjs(params.data.dateDebutEquipe).format('DD/MM/YYYY')
                    }
                    return params.data.dateDebutEquipe
                },
                flex: 1,
                resizable: false,
            },
        ]
        const finalColDefsMonEquipe = [...baseColDefsMonEquipe];
        const actionColDelete: ColDef =
            {
                headerName: '',
                colId:'deleteActionColumn',
                cellRenderer: (params: ICellRendererParams) => {
                    if(params.data && params.data.datefilled != null &&  params.data.datefilled === true)
                    {
                        const eDiv = document.createElement('div');
                        eDiv.innerHTML = `<button class="btn remove-item ng-star-inserted"><i class="bi-trash" style="color: var(--color-ko);font-size: 1.5rem;cursor:pointer;text-align: center;display: flex;"></i></button>`;
                        return eDiv;
                    }
                    else
                    {
                        return ''
                    }
                },
                tooltipValueGetter: (params: ITooltipParams) => {
                    const collaborateur = `${params.data.prenomCollaborateur || ''} ${params.data.nomCollaborateur || ''}`;
                    if(params.data && params.data.datefilled != null &&  params.data.datefilled === true)
                    {
                        return `Enlever ${collaborateur} de mon équipe`;
                    } else {
                        return null;
                    }
                },
                cellStyle: (params: any) => { // params peut être CellStyleParams
                    if(params.data && params.data.datefilled != null &&  params.data.datefilled === true)
                    {
                        return { background: 'var(--color-row-highlighted)' }; // Appliquer la couleur verte
                    } else {
                        return null;
                    }
                },
                sortable: false,
                filter: false,
                width: 80,
                resizable: false,
            }
        finalColDefsMonEquipe.push(actionColDelete);
        this.colDefsMonEquipe = finalColDefsMonEquipe;

    }

    buildColumnDefsMonEquipeAvenir(): void {
        const baseColDefsMonEquipeAvenir: ColDef[] = [
            {
                headerName: 'tri',
                valueGetter: (params) => params.data.datefilled,
                flex: 0,
                hide: true,
                sort: 'desc',
                sortIndex: 1 // Première clé de tri
            },
            {
                headerName: 'Collaborateurs',
                valueGetter: (params) => params.data.nomCollaborateur + ' ' + params.data.prenomCollaborateur,
                flex: 1,
                sort: 'asc',
                sortIndex: 2,
                cellStyle: (params: any) => { // params peut être CellStyleParams
                    if(params.data && params.data.datefilled != null &&  params.data.datefilled === true)
                    {
                        return { background: 'var(--color-row-highlighted)' };
                    } else {
                        return null;
                    }
                }
            },
            {
                headerName: 'Emploi repère',
                valueGetter: (params) => params.data.nomEmploi,
                flex: 1,

            },
            {
                headerName: 'Direction / agence / service',
                valueGetter: (params) => params.data.nomEntiteAffectation,
                flex: 1.1,
            },
            {
                headerName: 'Date de mouvement',
                headerTooltip: 'Date prévue d\'entrée ou de sortie de l\'équipe',
                valueGetter: (params) => params.data.mouvementDateEffet,
                flex: 1,
                filter:false,
            },
            {
                headerName: 'Mouvement',
                headerTooltip:'Entrées prochaines ou sorties prochaines',
                cellRenderer: (params: ICellRendererParams) => {
                    if(params.data && params.data.datefilled != null && params.data.matriculeSuperieurHierarchique === this.currentUserMatricule)
                    {
                        const eDiv = document.createElement('div');
                        eDiv.innerHTML = `<i class="bi bi-box-arrow-in-left in-color ng-star-inserted" style="color: var(--color-success);font-size: 1.5rem;cursor:pointer;text-align: center;display: flex;"></i>`;
                        return eDiv;
                    }
                    else
                    {
                        const eDiv = document.createElement('div');
                        eDiv.innerHTML = `<i class="bi bi-box-arrow-in-right in-color ng-star-inserted" style="color: var(--color-ko);font-size: 1.5rem;cursor:pointer;text-align: center;display: flex;"></i>`;
                        return eDiv;
                    }
                },
                tooltipValueGetter: (params: ITooltipParams) => {
                    const collaborateur = `${params.data.prenomCollaborateur || ''} ${params.data.nomCollaborateur || ''}`;
                    const manager = `${params.data.prenomSuperieurHierarchique || ''} ${params.data.nomSuperieurHierarchique || ''}`;
                    if(params.data && params.data.datefilled != null &&  params.data.matriculeSuperieurHierarchique === this.currentUserMatricule)
                    {
                        return `${collaborateur} arrive dans mon équipe`;
                    }
                    return `${collaborateur} va dans l'équipe de ${manager}`;
                },
                flex: 1,
                filter:false,
                resizable: false
            }
        ]
        const finalColDefsMonEquipeAvenir = [...baseColDefsMonEquipeAvenir];
        const actionColDeleteAvenir: ColDef =
            {
                headerName: '',
                colId:'deleteActionColumn',
                cellRenderer: (params: ICellRendererParams) => {
                    if(params.data && params.data.datefilled != null &&  params.data.datefilled === true)
                    {
                        const eDiv = document.createElement('div');
                        eDiv.innerHTML = `<button class="btn remove-item ng-star-inserted"><i class="bi-trash" style="color: var(--color-ko);font-size: 1.5rem;cursor:pointer;text-align: center;display: flex;"></i></button>`;
                        return eDiv;
                    }
                    else
                    {
                        return ''
                    }
                },
                tooltipValueGetter: (params: ITooltipParams) => {
                    const collaborateur = `${params.data.prenomCollaborateur || ''} ${params.data.nomCollaborateur || ''}`;
                    if(params.data && params.data.datefilled != null &&  params.data.datefilled === true)
                    {
                        return `Enlever ${collaborateur} de mon équipe`;
                    } else {
                        return null;
                    }
                },
                cellStyle: (params: any) => { // params peut être CellStyleParams
                    if(params.data && params.data.datefilled != null &&  params.data.datefilled === true)
                    {
                        return { background: 'var(--color-row-highlighted)' }; // Appliquer la couleur verte
                    } else {
                        return null;
                    }
                },
                sortable: false,
                filter: false,
                width: 80,
                resizable: false,
            }
        finalColDefsMonEquipeAvenir.push(actionColDeleteAvenir);
        this.colDefsMonEquipeAvenir = finalColDefsMonEquipeAvenir;
    }

    public onGridCellClicked(event: CellClickedEvent): void {
        const colId = event.column.getColId();  // Récupérer l'ID de la colonne cliquée
        const rowData = event.data;                    // Récupérer les données de la ligne
        switch (colId) {
            case 'deleteActionColumn':
                this.clickOnRemoveCollaborateur(rowData);
                break;
        }
    }

    constructor(private router: Router) {
        this.userSubscription = this.user$.pipe(
            map(userData => userData?.user?.matriculeCollaborateur) // Extrait le matricule
        ).subscribe(matricule => {
            this.currentUserMatricule = matricule || null;
        });

    }

    ngOnInit(): void {
        this.buildColumnDefsMonEquipe();
        this.buildColumnDefsMonEquipeAvenir();
        combineLatest([this.monEquipeActuelleSorted$, this.monEquipeAVenir$])
            .pipe(
                takeUntil(this.unsubscribe$),
                tap((mesEquipes) => {
                    const monEquipe = mesEquipes[0]
                    const monEquipeAVenir = mesEquipes[1]

                    !!monEquipe && monEquipe.length ? (this.collabsNumber = monEquipe.length) : 0

                    if ((!!monEquipe && monEquipe.length) || (!!monEquipeAVenir && monEquipeAVenir.length)) {
                        this.showValidateButton =
                            !!monEquipe?.find((collabs) => collabs.datefilled === true) ||
                            !!monEquipeAVenir?.find((collabs) => collabs.datefilled === true)
                    }
                    // scroll to last collab added
                    this.collaborateursSelected$
                        .pipe(
                            filter((collabs: Array<CollaborateurDto>) => collabs && collabs?.length > 0),
                            take(1),
                            tap((collabs) => {
                                if (collabs.length > 0) {
                                    this.matriculeToScrollTo = 'm' + collabs[collabs.length - 1]?.matriculeCollaborateur
                                }
                            })
                        )
                        .subscribe()

                    // Init search filters
                    this.collaborateurDomainService.searchReset()
                })
            )
            .subscribe()
    }

    ngOnDestroy() {
        this.unsubscribe$.next()
        this.unsubscribe$.complete()
    }

    public sortDataOn(event: any) {
        this.collaborateurDomainService.sortMonEquipe(event)
    }

    public addNewCollaborateur() {
        this.router.navigate(['/mon-equipe/nouveau-collaborateur'])
    }

    /**
     * Click on button 'remove selected collab' :
     *  - Search collab in store
     *  - Get prenom and nom for the confirmation modale.
     * @param event : matricule
     */
    public clickOnRemoveCollaborateur(event: any) {
        this.confirmRemoveModalIsVisible = true
        this.collaborateursSelected$
            .pipe(
                take(1),
                tap((collabs) => {
                    const collabFound = collabs.find(
                        (collab) => collab.matriculeCollaborateur === event.matriculeCollaborateur
                    )
                    if (collabFound) {
                        this.prenomCollaborateur = collabFound.prenomCollaborateur
                        this.nomCollaborateur = collabFound.nomCollaborateur
                        this.collabMatriculeToRemove = collabFound.matriculeCollaborateur
                    }
                    this.toastDomainService.removeToastMessage()
                })
            )
            .subscribe()
    }

    /**
     *  Remove collaborateur : after confirmation in modale :
     *  - remove collab in store (sliced from collaborateursSelected)
     *  - close modale
     *  - reset search
     * @param matricule
     */
    public removeCollab(matricule: string) {
        if (matricule) {
            this.collaborateurDomainService.removeCollab(matricule)

            this.collaborateurDomainService.searchReset()
        }
        this.confirmRemoveModalIsVisible = false
    }

    /**
     *  DOnnées pour la modale de confirmation d'ajout des nouveaux collabs
     *  - dans les selectedCOllaborateurs du store, on prend ceux qui ont un status selected et une date
     * pour afficher leur nom et prenom dans la modale.
     *
     */
    public showModalAddCollaborateurs() {
        this.collabsSelectedName = []
        const selectedCollabs = this.collaborateurDomainService.selectedCollaborateurs()
        selectedCollabs.forEach((item: any) => {
            if (item.datefilled && item.selected) {
                this.collabsSelectedName.push(item.nomCollaborateur + ' ' + item.prenomCollaborateur)
            }
        })
        this.confirmAddModalIsVisible = true
        this.toastDomainService.removeToastMessage()
    }

    /**
     *  Validate and add collaborateurs in dataBase
     *  - do Action from Store
     *
     */
    public validateAddCollaborateurs() {
        this.confirmAddModalIsVisible = false
        this.cdr.markForCheck()
        this.collaborateurDomainService.addSelectedCollabsInMyTeamAction()
            .pipe(
                switchMap(() => this.equipeGlobaleDomainService.loadEquipeGlobale()), // reload equipeGlobale
                tap(() => {
                    this.matriculeToScrollTo = ''
                    this.collaborateurDomainService.searchReset() // reset du search
                })
            )
            .subscribe({
                next:() => {
                    this.toastDomainService.addToastMessage(
                        TypeToast.success,
                        "Ajout collaborateur",
                        "Les collaborateurs ont bien été ajoutés à votre équipe"
                    )
                }
            })
    }

    protected readonly localeFr = localeFr;
}
